module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("eYB4P"))).then(() => parcelRequire('fThBo'));